import React, { useState, useEffect, useRef } from "react";

export default function SearchableTreatmentDropdown({
    getDataTreatmentByCategory,
    handleInputChange2,
    selectedTreatmentId,
    setSelectedTreatmentId,
    name,
    searchTerm,
    setSearchTerm,
    onSearch
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef();

    const filteredData = getDataTreatmentByCategory;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (item) => {
        setSelectedTreatmentId(item.id);
        handleInputChange2({ value: item.id, label: item.name });
        setIsOpen(false);
        setSearchTerm("");
    };

    return (
        <div style={{ position: "relative", width: "100%" }} ref={dropdownRef}>
            <div
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    padding: "8px",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    backgroundColor: "#fff",
                }}
            >
                {selectedTreatmentId
                    ? getDataTreatmentByCategory.find((t) => t.id === selectedTreatmentId)?.name
                    : "Pilih Treatment"}
            </div>

            {isOpen && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 1000,
                        marginTop: "2px",
                    }}
                >
                    {/* <div style={{ display: "flex", borderBottom: "1px solid #ced4da" }}>
                        <input
                            type="text"
                            placeholder="Cari treatment..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                flex: 1,
                                padding: "6px 8px",
                                boxSizing: "border-box",
                                border: "none",
                                outline: "none",
                            }}
                            name={name}
                        />
                        <button
                            type="button"
                            onClick={() => onSearch?.()}
                            style={{
                                padding: "6px 12px",
                                border: "none",
                                borderLeft: "1px solid #ced4da",
                                backgroundColor: "#f8f9fa",
                                cursor: "pointer",
                                fontSize: "12px",
                            }}
                        >
                            Cari
                        </button>
                    </div> */}
                    <div style={{ display: "flex", borderBottom: "1px solid #ced4da" }}>
                        <input
                            type="text"
                            placeholder="Cari treatment..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                flex: 1,
                                padding: "6px 8px",
                                boxSizing: "border-box",
                                border: "none",
                                outline: "none",
                            }}
                            name={name}
                        />
                        <button
                            type="button"
                            onClick={() => onSearch?.()}
                            style={{
                                padding: "6px 12px",
                                border: "none",
                                borderLeft: "1px solid #ced4da",
                                backgroundColor: "#f8f9fa",
                                cursor: "pointer",
                                fontSize: "12px",
                            }}
                        >
                            Cari
                        </button>
                    </div>
                    {filteredData.length > 0 ? (
                        filteredData.map((item) => (
                            <div
                                key={item.id}
                                onClick={() => handleSelect(item)}
                                style={{
                                    padding: "6px 8px",
                                    cursor: "pointer",
                                    backgroundColor:
                                        selectedTreatmentId === item.id ? "#007bff" : "#fff",
                                    color:
                                        selectedTreatmentId === item.id
                                            ? "#fff"
                                            : item.code_icd9 === null
                                                ? "black"
                                                : "blue",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {`${item.code_icd9 ? item.code_icd9 : "SDC"} | ${item.name}${item.code_icd9 ? " | Satu Sehat" : ""
                                    }`}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: "6px 8px", color: "#888" }}>Tidak ada data</div>
                    )}
                </div>
            )}
        </div>
    );
}
